import React, { useState, useEffect } from "react";

import "./stylesWeeklyChallenges.css";

import { Modal, Popover, Table } from "antd";
import {
  EditOutlined,
  DownOutlined,
  UpOutlined,
  CheckOutlined,
} from "@ant-design/icons";
import ManualPassPopup from "./ManualPassPopup/ManualPassPopup";
import { API_ROUTES } from "../../../../../api/ApiRoutes";
import createPrivateAdminPanelInstance from "../../../../../api/PrivateAdminPanelInstance";
import RebetLoader from "../../../../CommonComponents/RebetLoader/RebetLoader";

const leagues = [
  {
    value: "Rookie League",
    label: "Rookie League",
  },
  {
    value: "Varsity League",
    label: "Varsity League",
  },
  {
    value: "Pro League",
    label: "Pro League",
  },
  {
    value: "All-Star League",
    label: "All-Star League",
  },
];

function WeeklyChallenges({ userData }) {
  const token = JSON.parse(localStorage.getItem("token"));
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.IdToken
  );

  const [isManualPassPopupOpen, setIsManualPassPopupOpen] = useState(false);
  const [selectedChallengeId, setSelectedChallengeId] = useState(null);
  const [selectedTask, setSelectedTask] = useState({
    task_name: "",
    task_index: 0,
  });
  const [selectedBetId, setSelectedBetId] = useState(null);
  const [selectedReason, setSelectedReason] = useState(null);
  const [weeklyChallengesData, setWeeklyChallengesData] = useState({});
  const [modalKey, setModalKey] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedLeague, setSelectedLeague] = useState(leagues[0]);
  const [isApiRunning, setIsApiRunning] = useState(false);
  const [leagueDataCache, setLeagueDataCache] = useState({});

  // Transform API response to table format
  const transformedChallenges = React.useMemo(() => {
    const challengesProgress = weeklyChallengesData?.challenges_progress;

    if (!challengesProgress || !Array.isArray(challengesProgress)) return [];

    return challengesProgress.map((challenge, index) => {
      const taskNames = challenge.tasks?.map((task) => task.name) || [];
      const completedStatuses =
        challenge.tasks?.map((task) => (task.completed ? "Yes" : "No")) || [];
      console.log("completedStatuses", completedStatuses);
      const betIds =
        challenge.tasks?.map((task) => {
          if (task.bet_id) {
            return task.bet_id;
          } else {
            return "completed before tracked";
          }
        }) || [];
      const reasons = challenge.tasks?.map((task) => task.reason || "") || [];

      return {
        key: challenge.challenge_id || `challenge-${index}`,
        challenge_id: challenge.challenge_id,
        challenge_name: challenge.challenge_name,
        description: challenge.challenge_description.replace(/#/g, ""),
        reward: challenge.reward?.xp ? `${challenge.reward.xp} XP` : "N/A",
        tasks: taskNames,
        bet_id: betIds,
        completed: completedStatuses,
        reason: reasons,
      };
    });
  }, [weeklyChallengesData]);

  const columns = [
    {
      title: "Challenge ID",
      dataIndex: "challenge_id",
      key: "challenge_id",
      width: 150,
      render: (text) => (
        <div style={{ wordBreak: "break-word", whiteSpace: "normal" }}>
          {text}
        </div>
      ),
    },
    {
      title: "Challenge Name",
      dataIndex: "challenge_name",
      key: "challenge_name",
      width: 150,
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      width: 200,
      render: (text) => (
        <Popover
          content={text}
          trigger="hover"
          placement="topLeft"
          styles={{
            root: { maxWidth: 300 },
          }}
        >
          <div className="user-manager-game-pass-body-weekly-challenges-table-description">
            {text}
          </div>
        </Popover>
      ),
    },
    {
      title: "Reward",
      dataIndex: "reward",
      key: "reward",
      width: 100,
    },
    {
      title: "Tasks",
      dataIndex: "tasks",
      key: "tasks",
      render: (text, record) => (
        <div className="user-manager-game-pass-body-weekly-challenges-table-tasks">
          {text.map((task, index) => (
            <div
              //add unique key for each task
              key={`${record.challenge_id}-${task}`}
              className="user-manager-game-pass-body-weekly-challenges-table-tasks-task"
            >
              <div
                className={`user-manager-game-pass-body-weekly-challenges-table-tasks-icon ${
                  record.completed[index].includes("Yes") ? "yes" : "no"
                } `}
              ></div>
              <Popover
                content={task}
                trigger="hover"
                placement="topLeft"
                styles={{
                  root: { maxWidth: 300 },
                }}
              >
                <span
                  style={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    maxWidth: "140px",
                  }}
                >
                  {task}
                </span>
              </Popover>
            </div>
          ))}
        </div>
      ),
      width: 150,
    },
    {
      title: "Bet ID",
      dataIndex: "bet_id",
      key: "bet_id",
      width: 150,
      render: (text, record) => (
        <div className="user-manager-game-pass-body-weekly-challenges-table-bet-id">
          {text.map((bet, index) => (
            <Popover
              content={bet}
              trigger="hover"
              placement="topLeft"
              styles={{
                root: { maxWidth: 300 },
              }}
            >
              <div
                key={`${record.challenge_id}-${index}-${bet}`}
                style={{
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                {bet}
              </div>
            </Popover>
          ))}
        </div>
      ),
    },
    {
      title: "Completed",
      dataIndex: "completed",
      key: "completed",
      width: 120,
      render: (text, record) => (
        <div className="user-manager-game-pass-body-weekly-challenges-table-completed-container">
          {text.map((completed, index) => (
            <div
              key={`${record.challenge_id}-${index}-${completed}`}
              className={`user-manager-game-pass-body-weekly-challenges-table-completed ${completed.toLowerCase()}`}
            >
              {completed}
            </div>
          ))}
        </div>
      ),
    },
    {
      title: "Reason",
      dataIndex: "reason",
      key: "reason",
      width: 200,
      render: (text, record) => (
        <div className="user-manager-game-pass-body-weekly-challenges-table-reason">
          {text.map((reason, index) => {
            const isEmpty = !reason || reason.trim() === "";
            const displayText = isEmpty ? "-" : reason;

            return (
              <Popover
                key={`${record.challenge_id}-${reason}-${index}`}
                content={displayText}
                trigger="hover"
                placement="topLeft"
                styles={{
                  root: { maxWidth: 300 },
                }}
              >
                <div
                  className={`user-manager-game-pass-body-weekly-challenges-table-reason-text ${
                    isEmpty ? "empty-reason" : ""
                  }`}
                  style={{ height: "30px", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
                >
                  {displayText}
                </div>
              </Popover>
            );
          })}
        </div>
      ),
    },
    {
      title: "Edit",
      dataIndex: "edit",
      key: "edit",
      width: 100,
      fixed: "right",
      render: (text, record) => (
        <div className="user-manager-game-pass-body-weekly-challenges-table-edit">
          {record.bet_id.map((bet_id, index) => (
            <div
              key={`${record.challenge_id}-${index}-${bet_id}`}
              className="user-manager-game-pass-body-weekly-challenges-table-edit-icon"
            >
              <EditOutlined onClick={() => handleEdit(bet_id, record, index)} />
            </div>
          ))}
        </div>
      ),
    },
  ];

  const handleEdit = (bet_id, record, index) => {
    setSelectedChallengeId(record.challenge_id);
    setSelectedBetId(bet_id);
    setSelectedReason(record.reason[index]);
    setSelectedTask({
      task_name: record.tasks[index],
      task_index: index,
    });
    setModalKey((prev) => prev + 1);
    setIsManualPassPopupOpen(true);
  };

  const handleManualPassPopupOk = () => {
    setIsManualPassPopupOpen(false);
  };

  const handleManualPassPopupCancel = () => {
    setIsManualPassPopupOpen(false);
  };

  const toggleOpen = () => {
    setIsOpen(!isOpen);
  };

  const handleSelect = (league) => {
    setSelectedLeague(league);
    setIsOpen(false);
  };

  const handleUpdateTaskSuccess = (challengeId, taskIndex, reason, betId) => {
    const updateData = (prevData) => {
      // Clone the data
      const updatedData = { ...prevData };

      // Find the challenge and update the specific task
      if (updatedData.challenges_progress) {
        const challengeIndex = updatedData.challenges_progress.findIndex(
          (challenge) => challenge.challenge_id === challengeId
        );

        if (challengeIndex !== -1) {
          const updatedChallengesProgress = [
            ...updatedData.challenges_progress,
          ];
          const challenge = { ...updatedChallengesProgress[challengeIndex] };
          const tasks = [...challenge.tasks];

          // Update the specific task
          if (tasks[taskIndex]) {
            tasks[taskIndex] = {
              ...tasks[taskIndex],
              reason: reason,
              bet_id: betId,
              completed: "Yes",
            };
          }

          challenge.tasks = tasks;
          updatedChallengesProgress[challengeIndex] = challenge;
          updatedData.challenges_progress = updatedChallengesProgress;
        }
      }

      return updatedData;
    };

    // Update the current data
    setWeeklyChallengesData(updateData);

    // Update the cache for the current league
    const leagueValue = selectedLeague?.value;
    if (leagueValue) {
      setLeagueDataCache((prevCache) => ({
        ...prevCache,
        [leagueValue]: updateData(prevCache[leagueValue] || {}),
      }));
    }
  };

  const getAllWeeklyChallenges = async () => {
    const leagueValue = selectedLeague?.value;

    // Check if data exists in cache
    if (leagueDataCache[leagueValue]) {
      console.log("Using cached data for league:", leagueValue);
      setWeeklyChallengesData(leagueDataCache[leagueValue]);
      return;
    }

    setIsApiRunning(true);

    const params = {
      user_id: userData?.user_id,
      league: leagueValue,
    };

    try {
      const response = await PrivateAdminPanelInstance?.post(
        API_ROUTES.GET_WEEKLY_CHALLENGE_INFO,
        params
      );

      console.log("weekly challenges data", response?.data?.data);
      const data = response?.data?.data;

      // Store in cache
      setLeagueDataCache((prevCache) => ({
        ...prevCache,
        [leagueValue]: data,
      }));

      setWeeklyChallengesData(data);
    } catch (error) {
      console.log("[WeeklyChallenges] error:", error);
    } finally {
      setIsApiRunning(false);
    }
  };

  useEffect(() => {
    if (selectedLeague) {
      getAllWeeklyChallenges();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedLeague]);

  return (
    <div className="user-manager-game-pass-body-weekly-challenges">
      <Modal
        closable={false}
        open={isManualPassPopupOpen}
        onOk={handleManualPassPopupOk}
        onCancel={handleManualPassPopupCancel}
        footer={null}
        width={500}
      >
        <ManualPassPopup
          key={modalKey}
          onClosePressed={handleManualPassPopupCancel}
          selectedAdmin={userData}
          selectedChallengeId={selectedChallengeId}
          selectedTask={selectedTask}
          initialBetId={selectedBetId}
          initialReason={selectedReason}
          weeklyChallengesData={weeklyChallengesData}
          onUpdateSuccess={handleUpdateTaskSuccess}
        />
      </Modal>
      <div className="user-manager-game-pass-body-weekly-challenges-league-selector">
        <span className="user-manager-game-pass-body-weekly-challenges-league-selector-title">
          League
        </span>
        {/* <Select
          placeholder="Select"
          className="user-manager-game-pass-body-weekly-challenges-league-selector-select"
          filterOption={(input, option) =>
            (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
          }
          options={leagues}
        /> */}
        <div
          className={`custom-select ${isOpen ? "custom-select-opened" : ""}`}
        >
          <div className="custom-select-trigger" onClick={toggleOpen}>
            {
              <span className="custom-select-text">
                {selectedLeague?.label || "Select"}
              </span>
            }
            <div className="custom-select-icon">
              {isOpen ? <UpOutlined /> : <DownOutlined />}
            </div>
          </div>

          {isOpen && (
            <div className="custom-select-options">
              {leagues.map((league) => (
                <div
                  key={league.value}
                  className="custom-select-option"
                  onClick={() => handleSelect(league)}
                >
                  <div
                    className={`custom-select-option-box ${
                      selectedLeague?.value === league.value ? "selected" : ""
                    }`}
                  >
                    {selectedLeague?.value === league.value && (
                      <CheckOutlined className="custom-select-option-box-icon" />
                    )}
                  </div>
                  <span className="custom-select-option-text">
                    {league.label}
                  </span>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
      <div className="user-manager-game-pass-body-weekly-challenges-table">
        {isApiRunning ? (
          <RebetLoader height={"100px"} width={"100px"} />
        ) : (
          <Table
            tableLayout="fixed"
            rowKey={(record) => record.challenge_id}
            columns={columns}
            dataSource={transformedChallenges}
            scroll={{ x: 1500, y: 400 }}
            pagination={false}
          />
        )}
      </div>
    </div>
  );
}

export default WeeklyChallenges;
